import { EventEmitter } from '@angular/core';
import { Report } from '../../../../models/measure/report';
import { CommonConstant, longLetters, shortLetters } from '../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { AchooTextFieldComponent } from '../../../core/achoo-text-field/achoo-text-field.component';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { UserService } from '../../../services/user.service';
import { EventTrackerService } from '../../../services/event-tracker/event-tracker.service';
var MeasureBreadcumbComponent = /** @class */ (function () {
    function MeasureBreadcumbComponent(translate, userService, eventTracker) {
        this.translate = translate;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.reportList = [];
        this.selectReport = new Report();
        this.selectReportEvent = new EventEmitter();
        this.showReportList = false;
    }
    MeasureBreadcumbComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.reportList && changes.reportList.currentValue.length > 0) {
            this.showReportList = true;
            // deplay to update arrow position
            setTimeout(function () { return _this.updateArrowPosition(_this.selectReport.name); });
        }
        if (changes.selectReport) {
            this.selectedReportId = changes.selectReport.currentValue.id;
        }
    };
    Object.defineProperty(MeasureBreadcumbComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    MeasureBreadcumbComponent.prototype.onSelectReport = function (e) {
        var _this = this;
        if (e) {
            var newSelectedReport = this.reportList.find(function (report) { return report.id === _this.selectedReportId; });
            if (newSelectedReport) {
                this.selectReport = newSelectedReport;
                this.selectReportEvent.emit(newSelectedReport);
            }
        }
    };
    MeasureBreadcumbComponent.prototype.updateArrowPosition = function (reportName, arrowOffsetLeft) {
        if (!this.selectReport || !this.reportSelection) {
            return;
        }
        var reportFieldWidth;
        // use for fixed position
        if (arrowOffsetLeft) {
            reportFieldWidth = arrowOffsetLeft;
        }
        else if (!reportName || reportName.length === 0) {
            reportFieldWidth = CommonConstant.MAX_LENGTH_REPORT_NAME_FIELD;
        }
        else if (reportName.length > 0) {
            // dynamaic position
            var lengthOfUppercaseLetters = 0;
            var lengthOfLowercaseLetters = 0;
            for (var i = 0; i < reportName.length; i++) {
                if (this.isUpppercaseCharacter(reportName.charAt(i))) {
                    lengthOfUppercaseLetters += this.calculateUppercaseLetterLength(reportName.charAt(i));
                }
                else {
                    lengthOfLowercaseLetters += this.calculateLowercaseLetterLength(reportName.charAt(i));
                }
            }
            reportFieldWidth = lengthOfUppercaseLetters + lengthOfLowercaseLetters;
        }
        // update arrow position base on width of report name
        if (this.reportNameInputField && reportFieldWidth) {
            this.reportNameInputField._entryElement.nativeElement.style.width = reportFieldWidth + 'px';
            this.reportSelection.ngSelect.elementRef.nativeElement.style.backgroundPositionX = reportFieldWidth + 'px';
        }
    };
    MeasureBreadcumbComponent.prototype.isUpppercaseCharacter = function (chr) {
        return chr !== ' ' && chr === chr.toUpperCase();
    };
    /**
     * this method is used to calculate the length of uppercase character
     * @param letter
     * @returns {number}
     */
    MeasureBreadcumbComponent.prototype.calculateUppercaseLetterLength = function (letter) {
        // need 32px for long upper-case letter
        if (longLetters.indexOf(letter.toLowerCase()) >= 0) {
            return CommonConstant.UPPER_CASE_LONG_LETTER_LENGTH;
        }
        else if (shortLetters.indexOf(letter.toLowerCase()) >= 0) {
            // need 25px for normal upper-case letter
            return CommonConstant.UPPER_CASE_SHORT_LETTER_LENGTH;
        }
        else {
            // need 30px for normal upper-case letter
            return CommonConstant.UPPER_CASE_NORMAL_LETTER_LENGTH;
        }
    };
    /**
     * this method is used to calculate the length of lowercase character
     * @param letter
     * @returns {number}
     */
    MeasureBreadcumbComponent.prototype.calculateLowercaseLetterLength = function (letter) {
        // need 32px for long upper-case letter
        if (longLetters.indexOf(letter) >= 0) {
            return CommonConstant.LOWER_CASE_LONG_LETTER_LENGTH;
        }
        else if (shortLetters.indexOf(letter) >= 0) {
            // need 15px for normal upper-case letter
            return CommonConstant.LOWER_CASE_SHORT_LETTER_LENGTH;
        }
        else {
            // need 30px for normal upper-case letter
            return CommonConstant.LOWER_CASE_NORMAL_LETTER_LENGTH;
        }
    };
    Object.defineProperty(MeasureBreadcumbComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    return MeasureBreadcumbComponent;
}());
export { MeasureBreadcumbComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-breadcumb/measure-breadcumb.component.ts.pre-build-optimizer.js